"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _NavButtons = require("./NavButtons");

var _Carousel = require("./Carousel.styles");

var _indicators2 = require("../utils/indicators");

var _slide = require("../utils/slide");

var _fade = require("../utils/fade");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Carousel = function Carousel(props) {
  var carousel = (0, _react.useRef)();
  var indicators = (0, _react.useRef)();
  var controller = (0, _react.useRef)();
  var fitWidth = props.fitWidth || false;
  var fitHeight = props.fitHeight || true;
  var autoplay = props.autoplay || false;
  var pauseOnMouseOver = props.pauseOnMouseOver || false;
  var pause = (0, _react.useRef)(false);
  var delay = props.delay || 5000;
  var speed = props.speed || 250;
  var useArrowKey = props.useArrowKey || false;
  var useMouseWheel = props.useMouseWheel || false;
  var effect = props.effect || "slide";
  var hideController = props.hideController || false;
  var hideIndicators = props.hideIndicators || false;

  var itemCount = _react["default"].Children.count(props.children);

  var currentSlide = 0;
  (0, _react.useLayoutEffect)(function () {
    var _carousel = carousel.current;
    var _controller = controller.current;
    var _indicators = indicators.current;
    (0, _indicators2.setIndicator)(indicators, 0);
    hideController && (_controller.style.visibility = "hidden");
    itemCount <= 1 && (_controller.style.visibility = "hidden");
    hideIndicators && (_indicators.style.visibility = "hidden"); // Autoplay

    autoplay && autoToNextSlide();

    if (autoplay && pauseOnMouseOver) {
      _carousel.addEventListener("mouseenter", function () {
        pause.current = true;
      });

      _carousel.addEventListener("mouseleave", function () {
        pause.current = false;
      });
    } // Workaround for fade effect with position absolute


    effect === "fade" && _carousel.insertBefore(_carousel.firstChild, _carousel.lastChild.nextSibling); // Enable navigation with arrow key

    if (useArrowKey) {
      _carousel.addEventListener("mouseenter", function () {
        window.addEventListener("keydown", handleArrowKey);
      });

      _carousel.addEventListener("mouseleave", function () {
        window.removeEventListener("keydown", handleArrowKey);
      });
    }

    return function () {
      if (useArrowKey) {
        _carousel.removeEventListener("mouseenter", function () {
          window.addEventListener("keydown", handleArrowKey);
        });

        _carousel.removeEventListener("mouseleave", function () {
          window.removeEventListener("keydown", handleArrowKey);
        });
      }

      if (autoplay && pauseOnMouseOver) {
        _carousel.removeEventListener("mouseenter", function () {
          pause.current = true;
        });

        _carousel.removeEventListener("mouseleave", function () {
          pause.current = false;
        });
      }
    }; // eslint-disable-next-line
  }, []);

  var slideToNextSlide = function slideToNextSlide() {
    currentSlide === carousel.current.children.length - 1 ? currentSlide = 0 : currentSlide++;
    (0, _indicators2.setIndicator)(indicators, currentSlide);
    (0, _slide.slideNext)(carousel, speed);
  };

  var slideToPrevSlide = function slideToPrevSlide() {
    currentSlide === 0 ? currentSlide = carousel.current.children.length - 1 : currentSlide--;
    (0, _indicators2.setIndicator)(indicators, currentSlide);
    (0, _slide.slidePrev)(carousel, speed);
  };

  var fadeToNextSlide = function fadeToNextSlide() {
    currentSlide === carousel.current.children.length - 1 ? currentSlide = 0 : currentSlide++;
    (0, _indicators2.setIndicator)(indicators, currentSlide);
    (0, _fade.fadeNext)(carousel, speed);
  };

  var fadeToPrevSlide = function fadeToPrevSlide() {
    currentSlide === 0 ? currentSlide = carousel.current.children.length - 1 : currentSlide--;
    (0, _indicators2.setIndicator)(indicators, currentSlide);
    (0, _fade.fadePrev)(carousel, speed);
  };

  var autoToNextSlide = function autoToNextSlide() {
    setInterval(function () {
      if (!pause.current) {
        handleEffects(effect, "next");
      }
    }, delay);
  };

  var handleIndicators = function handleIndicators(index) {
    // times = number of slide to scroll
    var times = index - currentSlide; // times < 0 = go to prev slide

    if (times < 0) {
      for (var i = 0; i < Math.abs(times); i++) {
        handleEffects(effect, "prev");
      }
    } else {
      for (var _i = 0; _i < Math.abs(times); _i++) {
        handleEffects(effect, "next");
      }
    }

    currentSlide = index;
    (0, _indicators2.setIndicator)(indicators, currentSlide);
  };

  var handleMouseWheel = function handleMouseWheel(e) {
    if (e.deltaY < 0) {
      handleEffects(effect, "prev");
    } else {
      handleEffects(effect, "next");
    }
  };

  var handleArrowKey = function handleArrowKey(e) {
    if (e.keyCode === 37) {
      return handleEffects(effect, "prev");
    }

    if (e.keyCode === 39) {
      return handleEffects(effect, "next");
    }
  };

  var handleEffects = function handleEffects(effect, direction) {
    if (direction === "next") {
      switch (effect) {
        case "fade":
          return fadeToNextSlide();

        default:
          return slideToNextSlide();
      }
    }

    if (direction === "prev") {
      switch (effect) {
        case "fade":
          return fadeToPrevSlide();

        default:
          return slideToPrevSlide();
      }
    }
  };

  return _react["default"].createElement(_Carousel.Container, {
    width: props.width,
    height: props.height,
    onWheel: function onWheel(e) {
      return useMouseWheel && handleMouseWheel(e);
    }
  }, _react["default"].createElement(_Carousel.CarouselWrapper, {
    speed: speed
  }, _react["default"].createElement(_Carousel.CarouselBody, {
    "data-name": "carousel-body",
    ref: carousel,
    effect: effect
  }, _react["default"].Children.map(props.children, function (item, index) {
    return _react["default"].createElement(_Carousel.Item, {
      key: index,
      effect: effect,
      background: props.background,
      fitWidth: fitWidth,
      fitHeight: fitHeight
    }, item);
  })), _react["default"].createElement(_Carousel.Controller, {
    "data-name": "carousel-controller",
    ref: controller
  }, _react["default"].createElement(_Carousel.ButtonLeft, {
    onClick: function onClick() {
      return handleEffects(effect, "prev");
    },
    buttonColor: props.buttonColor,
    buttonPosition: props.buttonPosition
  }, _react["default"].createElement(_NavButtons.PrevButton, null)), _react["default"].createElement(_Carousel.ButtonRight, {
    onClick: function onClick() {
      return handleEffects(effect, "next");
    },
    buttonColor: props.buttonColor,
    buttonPosition: props.buttonPosition
  }, _react["default"].createElement(_NavButtons.NextButton, null))), _react["default"].createElement(_Carousel.Indicators, {
    "data-name": "carousel-indicators",
    ref: indicators,
    indicatorsColor: props.indicatorsColor
  }, _react["default"].Children.map(props.children, function (_, index) {
    return _react["default"].createElement("li", {
      key: index,
      onClick: function onClick() {
        return handleIndicators(index);
      }
    });
  }))));
};

var _default = Carousel;
exports["default"] = _default;